/** Modulo Aluno (30) — codigos em contracts/enums.yaml */
export const ALUNO_ACAO = {
  CRIAR: 301,
  ATUALIZAR: 302,
  REMOVER: 303,
} as const;

export const ALUNO_ACOES_MODULO = [
  ALUNO_ACAO.CRIAR,
  ALUNO_ACAO.ATUALIZAR,
  ALUNO_ACAO.REMOVER,
] as const;
